/*
 * @Author: yinheng_1108 heng.yin@definsys.com
 * @Description:
 */
/*
 * @Author: yinheng_1108 heng.yin@definsys.com
 * @Description: 
 */
export default {
    user: {
        baseInfo: 'Basic Info',
        roleAdd: 'Role Addtion',
        roleEdit: "Role Edit",
        roleDetail: "Role Detail",
        loginAccount: 'Account',
        Role: 'Role Name',
        accountPlaceholder: "please enter login account",
        password: 'Password',
        passwordPlaceholder: 'please enter login password',
        roleType: 'Role Type',
        roleTypePlaceholder: "please check Role Type",
        managerName: "Admin Name",
        managerNamePlaceholder: "please enter admin name",
        overview: 'Overview',
        overviewPlaceholder: 'please enter overview',
        accountRequired: "account is required",
        pwdRequired: "password is required",
        roleTypeRequired: "role type is required",
        managerRequired: "admin name is required",
        overviewRequired: "overview is required",
        charLength1_99: 'length between 1-99 characters',
        charLength2_5: "length between 2-5 characters",
        charLength2_20: "length between 2-20 characters",
        editSuccess: "edit success",
        InfoRequired: "The information is not yet complete",

        stop: "Deactivate",
        multiplexing: "multiplexing",
        recovery: "recovery",
        warning: 'Warning',
        warningText: 'The current operation will affect the normal use of this character. Please confirm if you want to make any changes',
        operateSuccess: "Operation successful"
    },
    jurisdiction: {
        role: 'Role',
        jurisdiction: 'Jurisdiction',
        warningText: "The current role operation has not been saved yet. Do you want to save it",
        roleNameRequired: "Role Name is Required",
        jurisdictionRequired: "Please select at least one permission",
    }
}



// WEBPACK FOOTER //
// ./src/views/install/install.en.js